import { Typography } from "@mui/material";

import { SKUStoreResourceCardMedia } from "@/features/SKUStore/components/ResourceCard/SKUStoreResourceCardMedia";

interface PurchasedProductCardProps {
  imageSrc?: string | null;
  imageAlt?: string;
  name: string;
  subtitle: string;
}

/** Image + name + price only — reuses the SKU store media card, dropping its top rail/status/action slots. */
export function PurchasedProductCard({
  imageSrc,
  imageAlt,
  name,
  subtitle,
}: PurchasedProductCardProps) {
  return (
    <SKUStoreResourceCardMedia
      imageAlt={imageAlt ?? name}
      imageSrc={imageSrc}
      layout="media"
      subtitle={
        <Typography
          component="span"
          sx={{
            color: "primary.main",
            fontWeight: (theme) => theme.typography.fontWeightScale.semiBold,
          }}
          variant="body1"
        >
          {subtitle}
        </Typography>
      }
      title={name}
    />
  );
}
